import { Skeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  LeftSection,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />
      <Container>
        <LeftSection>
          <CardContainer>
            <section>
              <header className="grid grid-cols-12 gap-x-4 gap-y-0 border-b px-1 pb-2 lg:gap-x-6">
                <div className="col-span-6">
                  <Skeleton className="h-3 w-16" />
                </div>
                <div className="col-span-6">
                  <Skeleton className="h-3 w-36" />
                </div>
              </header>
              {Array.from({ length: 2 }).map((_, i) => (
                <section key={i} className="grid grid-cols-12 items-end gap-x-4 gap-y-2 px-1 py-3 lg:gap-x-6">
                  <div className="col-span-6">
                    <Skeleton className="h-4 w-32" />
                  </div>
                  <div className="col-span-6">
                    <Skeleton className="h-10.5 w-full" />
                  </div>
                </section>
              ))}
            </section>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
